// Build a Gmail compose URL (opens gmail.com in a new tab)
export function buildGmailHref({ to, subject, body, cc = "", bcc = "" }) {
  const params = new URLSearchParams({
    view: "cm",   // compose
    fs: "1",      // full-screen
    tf: "1",      // minimal compose
    to,
    su: subject,
    body,
  });
  if (cc) params.set("cc", cc);
  if (bcc) params.set("bcc", bcc);
  return `https://mail.google.com/mail/u/0/?${params.toString()}`;
}

// Use for anchors that should open a new tab (and not trigger SPA routing)
export function openInNewTab(url, e) {
  if (e) { e.preventDefault(); e.stopPropagation(); }
  window.open(url, "_blank", "noopener,noreferrer");
}
